var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { TEAM_CACHE_LOCATION } from '@lucidlink/sdk';
import { InlineForm, TextInputField, translate } from '@lucidlink/uicore';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { PII_MASK_CLASS } from '#constants';
import { teamCacheValidationRules, teamCacheValidator, } from '../services/validation';
const TEAM_CACHE_LOCATION_ID = 'team-cache-location';
const TEAM_CACHE_LOCATION_NAME = 'teamCacheLocation';
export const TeamCacheLocation = ({ data, isSuccess, resetTooltip, setSetting, unsetSetting, }) => {
    _react_refresh_temp_2();
    const { errors: { teamCacheLocation: teamCacheLocationErrors }, formData: { teamCacheLocation = '' }, } = useFormRoot();
    const { isDefault, value } = data;
    const resetTeamCacheLocation = useCallback(() => {
        unsetSetting([TEAM_CACHE_LOCATION]);
    }, [unsetSetting]);
    const resetToDefault = isDefault
        ? undefined
        : {
            label: translate('Reset to default'),
            onReset: resetTeamCacheLocation,
            tooltip: resetTooltip,
        };
    const labelDefault = isDefault && value === ''
        ? translate('Enter hostname or IP address')
        : undefined;
    const labelTooltip = useMemo(() => [
        translate('Configure a shared cache to improve performance for your team.'),
    ], []);
    const setTeamCacheLocation = useCallback(() => setSetting([
        { fullName: TEAM_CACHE_LOCATION, value: teamCacheLocation },
    ]), [teamCacheLocation, setSetting]);
    return (_jsx(InlineForm, { cancelAriaLabel: translate('Cancel'), "data-testid": TEAM_CACHE_LOCATION_ID, description: translate('IPv4 and IPv6 supported. Use [ ] around IPv6.'), formElement: (labelProps) => (_jsx(TextInputField, { ...labelProps, autoFocus: true, clientErrorMessage: translate('Must be a valid URL'), "data-testid": TEAM_CACHE_LOCATION_ID, id: TEAM_CACHE_LOCATION_ID, initialValue: value, name: TEAM_CACHE_LOCATION_NAME, rules: teamCacheValidationRules(), validator: teamCacheValidator })), inputId: TEAM_CACHE_LOCATION_ID, isSaveAllowed: value !== teamCacheLocation && !teamCacheLocationErrors, isSuccess: isSuccess, label: translate('TeamCache server location'), labelDefault: labelDefault, labelTooltip: labelTooltip, onSave: setTeamCacheLocation, resetToDefault: resetToDefault, saveAriaLabel: translate('Save'), tooltipPosition: "right", value: value, valueClassName: PII_MASK_CLASS, width: "sm" }));
};
_react_refresh_temp_1 = TeamCacheLocation;
$RefreshReg$(_react_refresh_temp_1, "TeamCacheLocation");
_react_refresh_temp_2(TeamCacheLocation, "/tyOS7Wrd9aKUvrIWPjtGT5uv00=", false, () => [useFormRoot]);
